module.exports = __webpack_public_path__ + "media/packs/images/flags/DE-52af9ab082343c6cac9eb37cb511e074.svg";